// The API client, provided once at the root so every page uses the same one (and the same CSRF value).
import { createContext, useContext, type ReactNode } from "react";
import type { ApiClient } from "./client.js";

const ApiContext = createContext<ApiClient | null>(null);

export function ApiProvider({ client, children }: { client: ApiClient; children: ReactNode }) {
  return <ApiContext value={client}>{children}</ApiContext>;
}

export function useApi(): ApiClient {
  const client = useContext(ApiContext);
  if (client === null) throw new Error("useApi() outside <ApiProvider>");
  return client;
}
